// Mantine
import { MRT_ColumnDef } from 'mantine-react-table';
import { Text, useMantineTheme, useComputedColorScheme } from '@mantine/core';

// Interfaces
import { Remittance } from 'interfaces';

// Utils
import { formatNumberWithCommas } from 'utils/stringUtils';

// Custom
import { DataBadge } from 'components/common/DataBadge';

import { useCurrentSiteStore } from 'store/SiteStore';
import { formatDateTimeInputValue, parseDateTime } from 'utils/dateUtils';

export const RemittanceColumns = () => {
  const theme = useMantineTheme();
  const computedColorScheme = useComputedColorScheme('dark');
  const { timezone } = useCurrentSiteStore();

  const columns: MRT_ColumnDef<Remittance>[] = [
    {
      accessorKey: 'filename',
      header: 'File Name',
      accessorFn: (row) => {
        const chunks = row?.filename?.split('/');
        if (!chunks) {
          return undefined;
        }
        const base = chunks[chunks?.length - 1];
        return base;
      },
      Cell: ({ cell }) => (
        <Text
          style={{ color: theme.colors[`primary-${computedColorScheme}`][0] }}
          fw="bold"
        >
          {cell.getValue() as string}
        </Text>
      ),
    },
    {
      accessorKey: 'parsedAt',
      header: 'Intake Date',
      accessorFn: (row) =>
        formatDateTimeInputValue(
          parseDateTime(row.parsedAt, { zone: timezone })
        ),
    },
    {
      accessorKey: 'claims',
      header: 'Claim Count',
      maxSize: 75,
      Cell: ({ cell }) => {
        const claims = cell.getValue() as number;
        return <DataBadge>{claims}</DataBadge>;
      },
    },
    {
      accessorKey: 'totalFeeAssessed',
      header: 'Total Assessed',
      maxSize: 75,
      Cell: ({ cell }) => {
        const total = cell.getValue() as number;
        return <DataBadge>${formatNumberWithCommas(total)}</DataBadge>;
      },
    },
  ];
  return columns;
};
